import { render, staticRenderFns } from "./VideoCallUsers.vue?vue&type=template&id=299ced34&"
import script from "./VideoCallUsers.vue?vue&type=script&lang=js&"
export * from "./VideoCallUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports